import { useEffect} from "react";



const useGhanaLotto = (dispatch, totalData) => {
    console.log('useGhanaLotto')
    const target = "ghanaLotto"
    const parameters = {game_id: 218, take: totalData, sub_name: "" }

    useEffect(() => {
        const getGhanaLottoData = async () => {
            console.log('getGhanaLottoData')
            dispatch({type: "setLoading", payload: {target: target, loading: true}})
            dispatch({type: "setData", payload: {target: target, data: null}})
            const url = "https://trapi.easywin.ng/api/V2/lottodrawresult";

            try {
                const response = await fetch(url, {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify(parameters)
                })
                if (response.ok) {
                    const json = await response.json()
                    if (json.status === true) {
                        dispatch({type: "setData", payload: {target: target, data: json.data.list}})
                        dispatch({type: "setError", payload: {target: target, error: null}})
                    }
                } else {
                    throw new Error("Request error")
                }             
            } catch (error) {
                console.log(error)
                dispatch({type: "setError", payload: {target: target, error: error}})
                dispatch({type: "setData", payload: {target: target, data: null}})
            }
            dispatch({type: "setLoading", payload: {target: target, loading: false}})      
        }

        getGhanaLottoData()
        
    }, [])

    return null
}


export default useGhanaLotto;